export const EMPTY_ARRAY = [];
export const EMPTY_COMPONENT = () => null;
